<div class="container-modal">
	<header>
		<h2 freud-typography type="heading-md">
			{{ title }}
		</h2>
		<button (click)="onCancel()">
			<span class="freud-icon freud-icon-md freud-icon-x"></span>
		</button>
	</header>

	<div class="content-modal">
		<div class="container" [innerHTML]="subtitle"></div>
		<google-login-button
			*ngIf="googleLogin"
			(click)="onConfirm()"
		></google-login-button>
	</div>

	<footer *ngIf="!googleLogin">
		<div>
			<freud-button color="ghost" type="button" (click)="onCancel()">
				Cancelar
			</freud-button>

			<freud-button color="primary" type="button" (click)="onConfirm()">
				{{ labelButton }}
			</freud-button>
		</div>
	</footer>
</div>
